export interface Company {
    cvr: string;
    name: string;
    address: {
        lines: string;
        postcode: string;
        city: string;
        country: string;
    };
    phone: string;
    fax: string;
    email: string;
}

export default async (cvrNumber: string): Promise<Company | undefined> => {
    try {
        const response = await fetch(`https://cvrservice.dinero.dk/v2/details?q=${cvrNumber}`);

        let company: Company | undefined;

        if (response.status === 200) {
            const data = await response.json();

            company = {
                cvr: data.cvrNumber.toString(),
                name: data.name,
                address: {
                    lines: data.address,
                    postcode: data.zipCode,
                    city: data.city,
                    country: 'Denmark',
                },
                phone: data.phone,
                fax: data.fax,
                email: data.email,
            };
        }

        return company;
    } catch (error) {
        return undefined;
    }
};

/**
 * Same signature as the above method, but using our own rate-limited API.
 *
 * @param {(number | string)} cvrNumber
 * @returns Company information for the specified cvrNumber or undefined if unable to do so.
 */
export async function cvrLookupInternal(cvrNumber: number | string): Promise<Company | undefined> {
    try {
        const response = await fetch(`https://companies.e-conomic.com/dk/${cvrNumber}`);

        if (response.status === 200) {
            const data = await response.json();

            return {
                cvr: data.vat,
                name: data.name,
                address: {
                    lines: data.address,
                    postcode: data.zipcode,
                    city: data.city,
                    country: 'Denmark',
                },
                phone: data.phone,
                fax: data.fax,
                email: data.email,
            };
        }
    } catch {}

    return undefined;
}
